import React from 'react';
import { observer } from 'mobx-react';
import Loader from 'react-simple-loading';
import Notifications from '../Notifications/Notifications';
import Routes from '../Routes/Routes';

import 'url-search-params-polyfill';
import { UserContext, RootStoreContext } from '../../context';

import {
  checkStatus,
  getActiveCampaign,
  initializeGlobalSession,
  getAnchorPortalCampaign,
  getModalsData,
} from './services';
import TippingModal from '../TippingModal/TippingModal';
import { BlogProvider } from "../../hooks/useBlog";
import { overrideStatusResponse } from '../../utils/overrideStatusResponse';
import GlobalNotification from '../GlobalNotification/GlobalNotification';
import NotificationStore from '../../store/NotificationStore';

@observer
class App extends React.Component {

  static contextType = RootStoreContext;

  state = {
    user: {
      userDetails: {},
      token: ''
    },
    isLoaded: false,
    showCookieConsent: false,
    showPremiumUpgradeBar: false,
    userPremiumExpired: false,
    modalsData: [],
  };

  async componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const affiliateCode = urlParams.get('_atc');
    if (affiliateCode) {
      document.cookie = `_atc=${affiliateCode}; expires=0; path=/`;
    }
    const { error, data } = await checkStatus();

    if (data?.data?.authenticated) {
      sessionStorage['username'] = data.data.user.username;
      sessionStorage['token'] = data.data.user.token;
    }

    await overrideStatusResponse(data);

    const { error: err, data: campaignResponse } = await getActiveCampaign();
    const { data: response } = await getAnchorPortalCampaign();
    if (data?.data?.authenticated) {
      const { data: modalsResponse } = await getModalsData();
      this.setState({ modalsData: modalsResponse.data });
    }
    if (err) console.error(err);
    if (!error) {
      const userPremiumExpired = data.data.authenticated && !data.data.user.activeSubscription;
      try {
        await initializeGlobalSession(data.data, this.context);
      } catch (e) {
        console.error('Could not initialize global presence');
      }

      let activeCampaigns = [];

      const campaignData = campaignResponse?.data;
      if (campaignData) {
        if (Array.isArray(campaignData)) {
          activeCampaigns = campaignData;
        } else {
          activeCampaigns = [campaignData];
        }
      }

      this.setState({
        user: data.data,
        isLoaded: true,
        activeCampaigns,
        anchorPortalCampaign: (response && response.data) ? response.data : {},
        showPremiumUpgradeBar: userPremiumExpired && !campaignData,
        userPremiumExpired,
        showCookieConsent: !document.cookie.includes('notify_cookie_usage=true')
      });
    }
  }

  refreshModalsData = () => {
    getModalsData()
      .then(res => this.setState({ modalsData: res.data.data }))
  }

  closePremiumUpgradeBar = () => {
    this.setState({ showPremiumUpgradeBar: false });
  }

  acceptCookies = event => {
    event.preventDefault();
    document.cookie = 'notify_cookie_usage=true;max-age=2592000';
    this.setState({ showCookieConsent: false });
  }
  render() {
    const {
      user,
      showPremiumUpgradeBar,
      userPremiumExpired,
      activeCampaigns,
      anchorPortalCampaign,
      modalsData
    } = this.state;
    const { notificationMessage } = NotificationStore

    const notificationsAvailable = !(user.user && user.user.account.anchor);

    return this.state.isLoaded ? (
      <>
        <UserContext.Provider value={user}>
          <BlogProvider>
            {notificationsAvailable && <Notifications />}
            <Routes
              userPremiumExpired={userPremiumExpired}
              showPremiumUpgradeBar={showPremiumUpgradeBar}
              closePremiumUpgradeBar={this.closePremiumUpgradeBar}
              activeCampaigns={activeCampaigns}
              anchorPortalCampaign={anchorPortalCampaign}
              modalsData={modalsData}
              refreshModalsData={this.refreshModalsData}
            />
            <TippingModal user={user} />
            {notificationMessage && <GlobalNotification />}
          </BlogProvider>
        </UserContext.Provider>
      </>
    ) : <div className="flex items-center" style={{ minHeight: '100vh' }}><Loader color="white" /></div>;
  }
}

export default App;
